// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-pdf {\n  max-height: 80vh;\n  overflow-y: auto;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
